import React from 'react';
import {translation} from "./../helpers";

import {OzContainer, OzRow, OzCol, OzIcon} from "@ozwol/webui";


export default function Benefits({lang}) {
  return (
    <OzContainer>
      <center>
        <h1>{translation("benefits_title", lang)}</h1>
        {translation("benefits_description", lang)}
      </center>
      <br/><br/>
      <OzRow gap="25">
        <OzCol widthmd="4">
          <center>
            <OzIcon name="coins" size="60px" color="#00141f" />
            <h2>{translation("benefits_costs_title", lang)}</h2>
            {translation("benefits_costs_description", lang)}
          </center>
        </OzCol>
        <OzCol widthmd="4">
          <center>
            <OzIcon name="timer" size="60px" color="#00141f" />
            <h2>{translation("benefits_time_title", lang)}</h2>
            {translation("benefits_time_description", lang)}
          </center>
        </OzCol>
        <OzCol widthmd="4">
          <center>
            <OzIcon name="infinite" size="60px" color="#00141f" />
            <h2>{translation("benefits_operate_title", lang)}</h2>
            {translation("benefits_operate_description", lang)}
          </center>
        </OzCol>
      </OzRow>
    </OzContainer>
  )

}
